import { formatDate, formatPrice } from "@utilities/functions";
import { Client, CreditType, Sale } from "@utilities/types";
import { FC } from "react";

interface Props {
    client: Client
    sale: Sale
    credit: CreditType
}

export const OrderDetails: FC<Props> = ({ client, sale, credit }) => {
    return (
        <div className="p-4 space-y-4">
            <h2 className="text-xl font-semibold text-primary">Détails de la commande</h2>

            <div className="bg-base-100 p-4 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold mb-2">Informations client</h3>
                <p><strong>Nom :</strong> {client.firstname} {client.lastname}</p>
                <p><strong>Téléphone :</strong> {client.phoneNumber || 'Non renseigné'}</p>
                <p><strong>Email :</strong> {client.email || 'Non renseigné'}</p>
                <p><strong>Ville :</strong> {client.city || 'Non renseigné'}, {client.country || 'Pays non renseigné'}</p>
            </div>

            <div className="bg-base-100 p-4 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold mb-2">Informations commande</h3>
                <p><strong>Numéro de commande :</strong> {sale.orderNumber}</p>
                <p><strong>Date :</strong> {formatDate(sale.createAt)}</p>
                <p><strong>Total :</strong> {formatPrice(Number(sale.totalBasket))}</p>
                <p><strong>Montant payé :</strong> {formatPrice(sale.totalPay)}</p>
                <p><strong>Reste à payer :</strong> {formatPrice(credit.remainingToBePaid)}</p>
            </div>

            <div className="bg-base-100 p-4 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold mb-2">Articles commandés</h3>
                <ul className="space-y-3">
                    {sale.basket.map((item, i) => (
                        <li key={i} className="border p-3 rounded-md">
                            <p className="font-semibold">{item.product.name}</p>
                            <p>Quantité : {item.quantity}</p>
                            <p>Prix unitaire : {formatPrice(item.price)}</p>
                            {item.selectedColor && (
                                <p>Couleur : <span className="inline-block w-4 h-4 rounded-full border align-middle" style={{ backgroundColor: item.selectedColor }} /></p>
                            )}
                            {item.selectedSize && (
                                <p>Taille : {item.selectedSize}</p>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
